import { apiRequest } from "./api";
import type { ApprovalDenies } from "../types/index";
import type { ApprovalScope } from "../types/pages";

export interface ApprovalControlRow {
  userId: string;
  name: string;
  roleName: string | null;
  scopes: ApprovalScope[];
  approvalDenies: ApprovalDenies;
}

export const manageApprovalsApi = {
  list: (businessId: string) =>
    apiRequest<{ items: ApprovalControlRow[] }>(`/biz/${businessId}/approval-controls`),

  set: (businessId: string, userId: string, approvalDenies: ApprovalDenies) =>
    apiRequest<{ success: true }>(`/biz/${businessId}/approval-controls/${userId}`, {
      method: "PUT",
      body: { approvalDenies },
    }),
};
